import * as Sentry from '@sentry/react';
import { ApiError } from '@/lib/http';

const KNOWN_CONFLICTS = new Set([
  'proposal_closed',
  'proposal_replaced',
  'surface_removed',
  'proposal_unavailable',
  'surface_busy',
  'not_generated_by_template',
]);

export function reportReviewFailure(error: unknown, label: string): void {
  if (error instanceof ApiError) {
    if (error.status === 402 || error.status === 403) {
      console.warn(`${label} refused`, error);
      return;
    }
    if (error.status === 404 || (error.status === 409 && KNOWN_CONFLICTS.has(error.code))) return;
  }
  Sentry.captureException(error);
  console.error(`${label} failed`, error);
}
